export default function liveChatWidget(url: string, target: string) {
  window.LiveChatWidget = window.LiveChatWidget || {};
  window.LiveChatWidget.iframe = window.LiveChatWidget.iframe || {};
  window.LiveChatWidget.type = 'babka';
  window.LiveChatWidget.iframe.url = url;
  window.LiveChatWidget.iframe.target = target;
  const script = document.createElement('script');
  script.async = true;
  script.src = new URL('//cdn.chat.xsolla.com/widget/livechat-iframe.js', url).toString();
  document.body.append(script);
}
